<template>
  <v-container>
    <v-snackbar
      class="snackbar-top"
      v-model="notification.show"
      :top="true"
      :right="true"
      :color="notification.color"
    >
      {{ notification.message }}
      <v-btn
        fab small outlined
        @click="closeNotification"
      >
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>

    <v-row
      justify="center">
      <v-col cols="12" md="7">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{ $t('profile.account.title') }}
          </v-card-title>
          <v-card-text>
            <v-alert type="error" dismissible v-if="error" class="mt-5">{{error}}</v-alert>
            <v-form ref="form" v-model="valid" class="pt-2">
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                  :label="$t('forms.name')"
                  type="text"
                  v-model="name"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveSettings" :loading="loading">
              <v-icon class="mr-1">save</v-icon>
              {{$t('forms.save')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      justify="center">
      <v-col cols="12" md="7">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{ $t('profile.security.title') }}
          </v-card-title>
          <v-card-text>
            <v-alert type="errorSecurity" dismissible v-if="errorSecurity" class="mt-5">{{ errorSecurity }}</v-alert>
            <p class="body-1 font-weight-regular mt-3">
              {{ $t('profile.security.description') }}
            </p>
            <p class="body-1 font-weight-medium">
              <v-icon class="mt-n2">warning</v-icon>
              {{ $t('profile.security.warning') }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="resetPassword" :loading="loading">
              <v-icon class="mr-1">security</v-icon>
              {{ $t('login.recovery.title') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<style lang="scss">
  .v-snack--top {
      top: 5em !important;
  }
</style>

<script>
import firebase from 'firebase'
import { saveProfile } from '@/store/module/profile'
import { logout } from '@/store/service'

export default {
  data() {
    return {
      name: '',
      valid: false,
      loading: false,
      error: null,
      errorSecurity: null,
      notice: null,
      notification: {
        color: 'gree',
        show: false,
        message: ''
      },
    }
  },
  created() {
    this.name = this.$store.getters.user.data.displayName
  },
  methods: {
    showNotification(success, message) {
      this.notification.message = message
      this.notification.color = success ? 'green' : 'red'
      this.notification.show = true
    },
    closeNotification() {
      this.notification.show = false
      this.notification.message = ''
    },
    saveSettings() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.notice = null
        this.error = null

        let settings = {
          name: this.name
        }

        saveProfile(settings)
        .then(() => {
          let user_data = this.$store.getters.user.data
          user_data.displayName = this.name
          this.$store.dispatch('setUser', user_data)
          this.showNotification(true, this.$t("forms.saved-record"))
          this.loading = false
        })
        .catch(error => {
          this.error = error.message
          this.loading = false
        })
      }
    },
    resetPassword() {
      this.loading = true
      firebase
      .auth()
      .sendPasswordResetEmail(this.$store.getters.user.data.email)
      .then(() => {
        logout().then(() => {
          this.$router.push({ name: 'Login' })
        }).catch(function(error) {
          alert('Error: ' + error)
        })
      })
      .catch(error => {
        let message = ''
        switch (error.code) {
          case 'auth/invalid-email':
          message = this.$t('errors.auth.invalid-email')
          break
        case 'auth/user-not-found':
          message = this.$t('errors.auth.user-not-found')
          break
        default:
          message = error.message
          break
        }

        this.errorSecurity = message
        this.loading = false
      })
    }
  }
}
</script>
